/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * skill object
 * @export
 * @interface GetCharactersCharacterIdSkillsSkill
 */
export interface GetCharactersCharacterIdSkillsSkill {
    /**
     * active_skill_level integer
     * @type {number}
     * @memberof GetCharactersCharacterIdSkillsSkill
     */
    activeSkillLevel: number;
    /**
     * skill_id integer
     * @type {number}
     * @memberof GetCharactersCharacterIdSkillsSkill
     */
    skillId: number;
    /**
     * skillpoints_in_skill integer
     * @type {number}
     * @memberof GetCharactersCharacterIdSkillsSkill
     */
    skillpointsInSkill: number;
    /**
     * trained_skill_level integer
     * @type {number}
     * @memberof GetCharactersCharacterIdSkillsSkill
     */
    trainedSkillLevel: number;
}

/**
 * Check if a given object implements the GetCharactersCharacterIdSkillsSkill interface.
 */
export function instanceOfGetCharactersCharacterIdSkillsSkill(value: object): value is GetCharactersCharacterIdSkillsSkill {
    if (!('activeSkillLevel' in value) || value['activeSkillLevel'] === undefined) return false;
    if (!('skillId' in value) || value['skillId'] === undefined) return false;
    if (!('skillpointsInSkill' in value) || value['skillpointsInSkill'] === undefined) return false;
    if (!('trainedSkillLevel' in value) || value['trainedSkillLevel'] === undefined) return false;
    return true;
}

export function GetCharactersCharacterIdSkillsSkillFromJSON(json: any): GetCharactersCharacterIdSkillsSkill {
    return GetCharactersCharacterIdSkillsSkillFromJSONTyped(json, false);
}

export function GetCharactersCharacterIdSkillsSkillFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCharactersCharacterIdSkillsSkill {
    if (json == null) {
        return json;
    }
    return {
        
        'activeSkillLevel': json['active_skill_level'],
        'skillId': json['skill_id'],
        'skillpointsInSkill': json['skillpoints_in_skill'],
        'trainedSkillLevel': json['trained_skill_level'],
    };
}

export function GetCharactersCharacterIdSkillsSkillToJSON(json: any): GetCharactersCharacterIdSkillsSkill {
    return GetCharactersCharacterIdSkillsSkillToJSONTyped(json, false);
}

export function GetCharactersCharacterIdSkillsSkillToJSONTyped(value?: GetCharactersCharacterIdSkillsSkill | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'active_skill_level': value['activeSkillLevel'],
        'skill_id': value['skillId'],
        'skillpoints_in_skill': value['skillpointsInSkill'],
        'trained_skill_level': value['trainedSkillLevel'],
    };
}

